var destroyFns = [];
export default destroyFns;